import React from 'react';
import classNames from 'classnames';

/**
 * Verified seller badge icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} SVG icon
 */
const IconVerified = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1000 1000"
      role="none"
    >
      <path
        fill="#253748"
        stroke="#ebe2e5"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M905.38,500c0,223.89-181.5,405.38-405.38,405.38S94.62,723.89,94.62,500,276.11,94.62,500,94.62s405.38,181.5,405.38,405.38Z"
      />
      <g fill="#fff">
        <path d="M266.27,498.07h11.57l-30.38,65.85h-14.58l-30.38-65.85h11.85l25.96,56.72,25.96-56.72Z" />
        <path d="M353.29,508.04h-41.77v17.03h36.59v9.78h-36.59v19.19h43.08v9.88h-53.43v-65.85h52.11v9.97Z" />
        <path d="M419.89,498.07c6.11,0,11.85.94,16.74,4.61,5.27,4.04,8.37,10.35,8.37,17.03,0,7.71-3.67,17.03-14.67,20.7l16.84,23.52h-12.79l-15.52-21.73h-22.95v21.73h-10.25v-65.85h34.24ZM419.71,532.31c3.1,0,5.83-.47,8-1.32,4.61-1.88,7.06-5.74,7.06-11.19,0-4.61-2.16-8.37-6.77-10.35-2.26-.94-5.17-1.41-8.47-1.41h-23.61v24.27h23.8Z" />
        <path d="M486.4,498.07v65.85h-11.1v-65.85h11.1Z" />
        <path d="M572.2,498.07v10.07h-40.83v18.53h35.56v10.07h-35.56v27.19h-10.35v-65.85h51.17Z" />
        <path d="M609.17,498.07v65.85h-11.1v-65.85h11.1Z" />
        <path d="M695.9,508.04h-41.77v17.03h36.59v9.78h-36.59v19.19h43.08v9.88h-53.43v-65.85h52.12v9.97Z" />
        <path d="M728.27,498.07h29.73c6.4,0,12.89,1.6,17.97,4.61,9.69,5.55,15.52,16.09,15.52,28.5,0,13.45-6.68,24.18-17.5,29.35-4.51,2.16-9.97,3.39-15.62,3.39h-30.1v-65.85ZM757.9,553.95c4.7,0,9.12-1.22,12.79-3.39,6.4-3.86,10.35-10.63,10.35-19.28s-3.57-15.99-10.25-19.94c-3.57-2.07-8.18-3.2-13.36-3.2h-18.72v45.81h19.19Z" />
      </g>
      <path
        fill="#fff"
        fillOpacity="0.2"
        d="M577.57,551.93h8.65l36.61-226.36h101.86l-81.89,348.86h-103.19l-39.27-169.1-39.95,169.1h-103.19l-81.9-348.86h101.86l36.61,226.36h8.65l35.29-226.36h84.55l35.29,226.36h.01Z"
      />
    </svg>
  );
};

export default IconVerified;
